// Mock data for Takeover Tax Inc

export const partners = [
  {
    id: '1',
    name: 'Tamika Harvey',
    title: 'Owner & CEO',
    specialty: 'Audit Protection, Tax Services & Tax Planning',
    bio: 'Las Vegas native and founder of Takeover Tax Inc. With over 6 years of expertise in tax laws, IRS standards, and regulations, Tamika specializes in audit protection, comprehensive tax services, and strategic tax planning. As a dedicated mother of three and passionate advocate for financial wellness, she brings both professional excellence and genuine care to every client relationship.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop'
  },
  {
    id: '2',
    name: 'Shanay Hicks',
    title: 'Senior Tax Consultant',
    specialty: 'Personal & Business Tax Services',
    bio: 'Specializing in comprehensive tax solutions with over 10 years of experience helping clients maximize their returns.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop'
  },
  {
    id: '3',
    name: 'Cidni Gian',
    title: 'Tax Strategist',
    specialty: 'Personal & Business Tax Services',
    bio: 'Expert in tax strategies and helping individuals and entrepreneurs navigate complex tax regulations.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop'
  },
  {
    id: '4',
    name: 'Adam Missakian',
    title: 'Tax Specialist',
    specialty: 'Personal & Business Tax Services',
    bio: 'Focused on tax optimization and compliance for individuals and small to medium-sized businesses.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop'
  },
  {
    id: '5',
    name: 'Deidre Dennis',
    title: 'Tax Consultant',
    specialty: 'Personal & Business Tax Services',
    bio: 'Dedicated to providing personalized tax preparation services with attention to detail for all clients.',
    image: 'https://images.unsplash.com/photo-1590086782957-93c06ef21604?w=400&h=400&fit=crop'
  },
  {
    id: '6',
    name: 'Kayla Kissinger',
    title: 'Tax Advisor',
    specialty: 'Personal & Business Tax Services',
    bio: 'Passionate about helping individuals and business owners achieve financial success through smart tax planning.',
    image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400&h=400&fit=crop'
  },
  {
    id: '7',
    name: 'Kandi Cole',
    title: 'Senior Tax Preparer',
    specialty: 'Personal & Business Tax Services',
    bio: 'Expert in personal and business tax situations, ensuring every deduction and credit is maximized.',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=400&fit=crop'
  },
  {
    id: '8',
    name: 'Jada Gilkerson',
    title: 'Tax Professional',
    specialty: 'Personal & Business Tax Services',
    bio: 'Specialized in comprehensive tax preparation and planning for individuals and businesses.',
    image: 'https://images.unsplash.com/photo-1582610285985-a42d9193f2fd?w=400&h=400&fit=crop'
  },
  {
    id: '9',
    name: 'Kyia Stewart',
    title: 'Tax Consultant',
    specialty: 'Personal & Business Tax Services',
    bio: 'Expert in handling personal and business tax situations with precision and care.',
    image: 'https://images.unsplash.com/photo-1574034589502-9f8a1ed46fa7?w=400&h=400&fit=crop'
  },
  {
    id: '10',
    name: 'Lisa Welch',
    title: 'Senior Tax Advisor',
    specialty: 'Personal & Business Tax Services',
    bio: 'Helping individuals and business owners navigate tax complexities with confidence and expertise.',
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=400&h=400&fit=crop'
  },
  {
    id: '11',
    name: 'Nasrae Young',
    title: 'Tax Specialist',
    specialty: 'Personal & Business Tax Services',
    bio: 'Focused on delivering comprehensive tax solutions for both personal and business clients.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop'
  }
];

export const services = [
  {
    id: '1',
    title: 'Individual Tax Preparation',
    description: 'Comprehensive personal tax filing services tailored to your unique financial situation.',
    icon: 'User'
  },
  {
    id: '2',
    title: 'Business Tax Services',
    description: 'Expert business tax preparation and planning for sole proprietors, LLCs, and corporations.',
    icon: 'Building2'
  },
  {
    id: '3',
    title: 'Tax Planning & Strategy',
    description: 'Proactive tax planning to minimize liability and maximize your financial outcomes.',
    icon: 'TrendingUp'
  },
  {
    id: '4',
    title: 'Audit Support',
    description: 'Professional representation and support if you face an IRS audit or inquiry.',
    icon: 'Shield'
  },
  {
    id: '5',
    title: 'Bookkeeping Services',
    description: 'Accurate bookkeeping and financial record management throughout the year.',
    icon: 'FileText'
  },
  {
    id: '6',
    title: 'Estate & Trust Tax',
    description: 'Specialized services for estate planning and trust tax preparation.',
    icon: 'Home'
  }
];

export const filingStatuses = [
  'Single',
  'Married Filing Jointly',
  'Married Filing Separately',
  'Head of Household',
  'Qualifying Widow(er)'
];

export const taxTypes = [
  'Individual Tax Return',
  'Business Tax Return',
  'Self-Employed/1099',
  'Corporate Tax',
  'Estate/Trust Tax',
  'Amended Return',
  'Tax Planning Consultation',
  'Other'
];
